export enum ApiMode {
  Live = "live",
  Test = "test",
}

export enum FdkTheme {
  Light = "light",
  Dark = "dark",
}

export enum WidgetMode {
  SearchOnly = "search-only", //used to search for an organization and connect to it. Does not require authentication
  Connect = "connect", //used to connect a patient directly to an organization. requires a reconnect-org-connection-id or brandId, portalId and endpointId
  Tefca = "tefca", //used to connect a patient to an organization using TEFCA.
}

export enum ConnectionStatus {
  Authorized = "authorized",
  Revoked = "revoked"
}

export enum ConnectMode {
  Redirect = "redirect",
  Popup = "popup",
  Websocket = "websocket",
}

export enum CspType {
  ClearCsp = "clear_csp",
  IdmeCsp = "idme_csp",
}

export enum SourceCredentialType {
  SourceCredentialTypeSmartOnFhir  = "smart_on_fhir",   // SMART on FHIR authorization (default)
	SourceCredentialTypeTefcaDirect  = "tefca_direct",    // TEFCA Direct authorization
	SourceCredentialTypeTefcaFacilitated = "tefca_facilitated", // TEFCA Facilitated FHIR authorization (SMART on FHIR under the hood, but initially populated by TEFCA RLS response)
	SourceCredentialTypeMedicareDirect = "medicare_direct", // Medicare Direct authorization
}

//where possible, these events should
export enum EventTypes {
  EventTypeWidgetConfigError = "widget.config_error", //triggered when the widget is unable to load due to a configuration error
  EventTypeWidgetClose = "widget.close", //triggered when the user requests to close the widget
  EventTypeWidgetComplete = "widget.complete", //triggered when the user requests to close the widget after connecting all accounts they want to

  EventTypeConnectionPending = "patient.connection_pending",
  EventTypeConnectionSuccess = "patient.connection_success",
  EventTypeConnectionFailed = "patient.connection_failed",

  EventTypeSearchQuery = "search.query",
}

export enum SDKMode {
  None = "none", //no SDK mode, the widget will not assume the use of an SDK, all messaging will be done through the message bus.
  ReactNative = "react-native", //the widget will assume the use of a React Native SDK, and will communicate with the React Native component through the message bus.
  Flutter = "flutter", //the widget will assume the user of a Flutter SDK
}

// these entities are only used in react-native, to identify the different communication channels between the React Native component and the WebViews
// changes here should be reflected in the react-native component, fasten-connect-api callback and customer code.
// these cannot be modified.
export enum CommunicationEntity {
  PrimaryWebView = 'FASTEN_CONNECT_PRIMARY_WEBVIEW',
  ModalWebView = 'FASTEN_CONNECT_MODAL_WEBVIEW',
  ReactNativeComponent = 'FASTEN_CONNECT_REACT_WEBVIEW', //this is the Fasten Connect React Native component that contains the two WebViews (this file)
  External = 'FASTEN_CONNECT_EXTERNAL', // this is data that will be sent to the customer's app, for them to handle.
}


export const ConnectWindowTimeout = 20*60*1000 //wait 20 minutes
export const WebsocketHeartbeatInterval = 4*60*1000
export const WebsocketKeepaliveMessageType = 'fasten.websocket.keepalive'
export const WebsocketAcknowledgementMessageType = 'fasten.websocket.ack'
export const WebsocketMessageIdField = 'message_id'
